export default {
    styleOverrides: {
      root: {
        paddingLeft: '8px',
        paddingRight: '8px'
      },
    },
}